import { useRef, useState } from "react";
import { TooltipTrigger, Tooltip as Tip, TooltipContent } from "@/components/ui/tooltip";

type TruncatedCellProps = {
  text: string;
  className?: string;
};

/**
 * Renders text truncated with ellipsis. Shows a tooltip with the full text only
 * when the content is actually overflowing (i.e. truncated).
 */
export function TruncatedCell({ text, className }: TruncatedCellProps) {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = () => {
    if (spanRef.current) {
      setIsTruncated(spanRef.current.scrollWidth > spanRef.current.offsetWidth);
    }
  };

  const span = (
    <span
      ref={spanRef}
      className={`block truncate ${className ?? ""}`}
      onMouseEnter={checkTruncation}
    >
      {text}
    </span>
  );

  if (!isTruncated) {
    return (
      <Tip>
        <TooltipTrigger asChild onMouseEnter={checkTruncation}>
          {span}
        </TooltipTrigger>
      </Tip>
    );
  }

  return (
    <Tip>
      <TooltipTrigger asChild>{span}</TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tip>
  );
}
